var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initLineItemCard = /* @__PURE__ */ __name(($el, lineItemKey) => {
  const random_id = utils.shortUUID();
  const cart = Alpine.store("cart");
  let lineItem = Shopify.designMode ? cart.state.items.find((item) => item.key === lineItemKey) ?? cart.state.items.find((item) => !!item?.properties?._p_id) ?? cart.state.items.find((item) => !item?.properties?._p_id_link) ?? cart.state.items[0] : cart.state.items.find((item) => item.key === lineItemKey);
  if (!lineItem) {
    for (const item of cart.state.items ?? []) {
      const components = item.item_components.map((component) => ({ ...component, item_components: [] }));
      lineItem = components?.find((compoment) => compoment.key === lineItemKey);
    }
  }
  const children = lineItem?.properties?._p_id ? cart.state.items.filter((child) => child?.properties?._p_id_link === lineItem?.properties?._p_id && child.quantity)?.map((child) => {
    let product2 = _products[child?.handle];
    if (!product2) {
      _product.getProductData(child?.handle, child?.product_id).then((prod) => {
        const index = state.children.findIndex((line) => line.line_item?.key === child?.key);
        if (index !== -1) {
          state.children[index] = {
            line_item: child,
            product: prod,
            variant: prod?.variants?.find((variant3) => variant3.id === child?.variant_id)
          };
        }
      });
    }
    product2 ?? (product2 = _products[child?.handle]);
    const variant2 = product2?.variants?.find((variant3) => variant3.id === child?.variant_id);
    return {
      line_item: child,
      product: product2,
      variant: variant2
    };
  }) : [];
  let product = _products[lineItem?.handle];
  if (!product) {
    _product.getProductData(lineItem?.handle, lineItem?.product_id).then((prod) => {
      state.product = prod;
      state.variant = prod?.variants?.find((variant2) => variant2.id === lineItem?.variant_id);
      state.hydrated = true;
    });
  }
  product ?? (product = _products[lineItem?.handle]);
  const variant = product?.variants?.find((variant2) => variant2.id === lineItem?.variant_id);
  const state = window.Alpine.reactive({
    random_id,
    subscriptionIsChanging: false,
    hydrated: !!variant,
    line_item: lineItem,
    product,
    variant,
    url: lineItem?.url,
    children: [...children],
    price: lineItem?.final_price,
    compare_at_price: Math.max(
      lineItem?.original_price ?? 0,
      variant?.compare_at_price ?? 0,
      lineItem?.selling_plan_allocation?.compare_at_price ?? 0
    ),
    bundle_price: lineItem?.final_price + (children?.reduce(
      (acc, child) => acc += child?.line_item?.final_price * (child?.line_item?.quantity / lineItem.quantity) || 0,
      0
    ) || 0),
    bundle_compare_at_price: Math.max(
      lineItem?.original_price ?? 0,
      variant?.compare_at_price ?? 0,
      lineItem?.selling_plan_allocation?.compare_at_price ?? 0
    ) + (children?.reduce(
      (acc, child) => acc += Math.max(
        child?.line_item?.original_price * (child?.line_item?.quantity / lineItem.quantity) || 0,
        child?.variant?.compare_at_price * (child?.line_item?.quantity / lineItem.quantity) || 0,
        child?.line_item?.selling_plan_allocation?.compare_at_price * (child?.line_item?.quantity / lineItem.quantity) || 0
      ),
      0
    ) || 0),
    quantity_limit: !children?.length ? Math.min(
      variant?.inventory_management === "shopify" && variant?.inventory_policy === "deny" ? variant?.inventory_quantity - cart.state.items.reduce(
        (acc, line) => acc += line.variant_id === variant?.id && line.key !== lineItem.key ? line.quantity : 0,
        0
      ) : 9999
    ) : Math.min(
      variant?.inventory_management === "shopify" && variant?.inventory_policy === "deny" ? variant?.inventory_quantity : 9999,
      ...children.map((child) => {
        const quantity_ratio = child.line_item.quantity / lineItem?.quantity;
        return child?.variant?.inventory_management === "shopify" && child?.variant?.inventory_policy === "deny" ? Math.floor(
          (child?.variant?.inventory_quantity - cart.state.items.reduce(
            (acc, line) => acc += line.variant_id === child?.variant?.id && line.key !== child.line_item.key ? line.quantity : 0,
            0
          )) / quantity_ratio
        ) : 9999;
      })
    )
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    return content.split(",")?.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  const hideIfEmpty = /* @__PURE__ */ __name((element, hide_if_empty, isEmpty = false) => {
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        element.closest(`.shopify-section`)?.classList.toggle("!hidden", isEmpty);
        break;
      case "container":
        element.closest(`[data-style-id]:not([data-style-id="${element.getAttribute("data-style-id")}"])`)?.classList.toggle("!hidden", isEmpty);
        break;
      case "block":
        break;
    }
  }, "hideIfEmpty");
  const showConditionally = /* @__PURE__ */ __name((condition, bundle) => {
    switch (condition) {
      case "no_addon_products":
        return !state.children?.length;
      case "addon_products":
        return !!state.children?.length;
      case "always": {
        return true;
      }
      case "with_subscriptions": {
        return !!state.line_item?.selling_plan_allocation?.selling_plan?.id;
      }
      case "no_subscriptions": {
        return !state.line_item?.selling_plan_allocation?.selling_plan?.id;
      }
      case "with_variants": {
        return state?.product?.variants?.length > 1;
      }
      case "no_variants": {
        return state?.product?.variants?.length <= 1;
      }
    }
  }, "showConditionally");
  Alpine.effect(() => {
    let lineItem2 = Shopify.designMode ? cart.state.items.find((item) => item.key === lineItemKey) ?? cart.state.items.find((item) => !!item?.properties?._p_id) ?? cart.state.items.find((item) => !item?.properties?._p_id_link) ?? cart.state.items[0] : cart.state.items.find((item) => item.key === lineItemKey);
    if (!lineItem2) {
      for (const item of cart.state.items ?? []) {
        const components = item.item_components.map((component) => ({ ...component, item_components: [] }));
        lineItem2 = components?.find((compoment) => compoment.key === lineItemKey);
      }
    }
    if (!utils.deepEqual(lineItem2, state.line_item)) {
      state.line_item = lineItem2;
    }
  });
  Alpine.effect(() => {
    state.children = state?.line_item?.properties?._p_id ? cart.state.items.filter((child) => child?.properties?._p_id_link === state?.line_item?.properties?._p_id && child.quantity)?.map((child) => {
      let product2 = _products[child?.handle];
      if (!product2) {
        _product.getProductData(child?.handle, child?.product_id).then((prod) => {
          const index = state.children.findIndex((line) => line.line_item?.key === child?.key);
          if (index !== -1) {
            state.children[index] = {
              line_item: child,
              product: prod,
              variant: prod?.variants?.find((variant3) => variant3.id === child?.variant_id)
            };
          }
        });
      }
      product2 ?? (product2 = _products[child?.handle]);
      const variant2 = product2?.variants?.find((variant3) => variant3.id === child?.variant_id);
      return {
        line_item: child,
        product: product2,
        variant: variant2
      };
    }) : [];
    state.price = state.line_item?.final_price;
    state.compare_at_price = Math.max(
      state.line_item?.original_price ?? 0,
      state.variant?.compare_at_price ?? 0,
      state.line_item?.selling_plan_allocation?.compare_at_price ?? 0
    );
    state.bundle_price = state.line_item?.final_price + (state.children?.reduce(
      (acc, child) => acc += child?.line_item?.final_price * (child?.line_item?.quantity / state.line_item.quantity) || 0,
      0
    ) || 0);
    state.bundle_compare_at_price = Math.max(
      state.line_item?.original_price ?? 0,
      state.variant?.compare_at_price ?? 0,
      state.line_item?.selling_plan_allocation?.compare_at_price ?? 0
    ) + (state.children?.reduce(
      (acc, child) => acc += Math.max(
        child?.line_item?.original_price * (child?.line_item?.quantity / state.line_item.quantity) || 0,
        child?.variant?.compare_at_price * (child?.line_item?.quantity / state.line_item.quantity) || 0,
        child?.line_item?.selling_plan_allocation?.compare_at_price * (child?.line_item?.quantity / state.line_item.quantity) || 0
      ),
      0
    ) || 0);
    state.quantity_limit = !state.children?.length ? Math.min(
      state.variant?.inventory_management === "shopify" && state.variant?.inventory_policy === "deny" ? state.variant?.inventory_quantity - cart.state.items.reduce(
        (acc, line) => acc += line.variant_id === state.variant?.id && line.key !== state?.line_item?.key ? line.quantity : 0,
        0
      ) : 9999
    ) : Math.min(
      state.variant?.inventory_management === "shopify" && state.variant?.inventory_policy === "deny" ? state.variant?.inventory_quantity : 9999,
      ...state.children.map((child) => {
        const quantity_ratio = child.line_item.quantity / state.line_item?.quantity;
        return child?.variant?.inventory_management === "shopify" && child?.variant?.inventory_policy === "deny" ? Math.floor(
          (child?.variant?.inventory_quantity - cart.state.items.reduce(
            (acc, line) => acc += line.variant_id === child?.variant?.id && line.key !== child.line_item.key ? line.quantity : 0,
            0
          )) / quantity_ratio
        ) : 9999;
      })
    );
  });
  return {
    line_card: state,
    $el,
    showConditionally,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels,
    hideIfEmpty
  };
}, "initLineItemCard");
const hydrateLineItemCard = /* @__PURE__ */ __name(($el, card_handle, line_item_key, classes = []) => {
  const node = document.querySelector(`[data-line-item-card='${card_handle}']`)?.cloneNode(true);
  if (!node) {
    $el.setAttribute("data-intersected", "true");
    const mo = new MutationObserver((mutation, obs) => {
      if ($el.hasAttribute("data-cards-loaded")) {
        $el.removeAttribute("data-intersected");
        const node2 = document.querySelector(`[data-line-item-card='${card_handle}']`)?.cloneNode(true);
        if (node2 && $el && $el.parentNode) {
          node2?.removeAttribute(`data-line-item-card`);
          node2?.setAttribute("data-line-item-key", line_item_key);
          node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
            el.remove();
          });
          node2.classList.add(...classes);
          $el.parentNode.replaceChild(node2, $el);
        }
        mo.disconnect();
      }
    });
    mo.observe($el, { attributes: true });
    return;
  }
  if (node && $el && $el.parentNode) {
    node?.removeAttribute(`data-line-item-card`);
    node?.setAttribute("data-line-item-key", line_item_key);
    node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
      el.remove();
    });
    node.classList.add(...classes);
    $el.parentNode.replaceChild(node, $el);
  }
}, "hydrateLineItemCard");
window._sections["initLineItemCard"] = initLineItemCard;
window._sections["hydrateLineItemCard"] = hydrateLineItemCard;
